function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { v4 as uuid } from 'uuid';
import Img from '../../common/Img.react';
var NewsArticle = function NewsArticle(_ref) {
  var _ourTeamArticle$silho, _ourTeamArticle$silho2;
  var hero = _ref.hero,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'default' : _ref$type,
    title = _ref.title,
    ourTeamArticle = _ref.ourTeamArticle;
  var bucket = useSelector(function (s) {
    return s.config.bucket;
  });
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    current = _useState2[0],
    setCurrent = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    timer = _useState4[0],
    setTimer = _useState4[1];
  var _useState5 = useState(uuid()),
    _useState6 = _slicedToArray(_useState5, 1),
    id = _useState6[0];
  var _useParams = useParams(),
    articleID = _useParams.articleID;
  useEffect(function () {
    $("#".concat(id, "0")).css({
      opacity: 1
    });
  }, []);
  useEffect(function () {
    if (timer) clearTimeout(timer);
    if (hero.length === 0) return;
    setTimer(setTimeout(function () {
      setCurrent(current === hero.length - 1 ? 0 : current + 1);
    }, 6000));
  }, [hero, current]);
  useEffect(function () {
    hero.forEach(function (x, i) {
      $("#".concat(id).concat(i)).css({
        opacity: i === current ? 1 : 0
      });
    });
    if (hero.length > 1) {
      hero.forEach(function (x, i) {
        if (i === current) $("#nav".concat(id).concat(i)).addClass('a-hero__nav--selected');else $("#nav".concat(id).concat(i)).removeClass('a-hero__nav--selected');
      });
    }
  }, [current]);
  if (hero.length === 0) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "a-hero a-hero__".concat(type, " ").concat(articleID ? 'a-hero__wide' : '')
  }, hero.map(function (x, i) {
    return /*#__PURE__*/React.createElement(Img, {
      src: "".concat(bucket, "/").concat(x.filename),
      style: {
        parent: {
          position: 'absolute',
          opacity: 0
        }
      },
      id: "".concat(id).concat(i),
      alt: x.altTag || null,
      key: x._id
    });
  }), type === 'product' && /*#__PURE__*/React.createElement("div", {
    className: "a-hero--title"
  }, title), type === 'team' && /*#__PURE__*/React.createElement("img", {
    className: "a-team__silhouette",
    src: "".concat(bucket, "/").concat(ourTeamArticle === null || ourTeamArticle === void 0 ? void 0 : (_ourTeamArticle$silho = ourTeamArticle.silhouette) === null || _ourTeamArticle$silho === void 0 ? void 0 : _ourTeamArticle$silho.filename),
    alt: ourTeamArticle === null || ourTeamArticle === void 0 ? void 0 : (_ourTeamArticle$silho2 = ourTeamArticle.silhouette) === null || _ourTeamArticle$silho2 === void 0 ? void 0 : _ourTeamArticle$silho2.altTag
  }), /*#__PURE__*/React.createElement("div", {
    className: "a-hero__nav"
  }, hero.length > 1 && hero.map(function (x, i) {
    return /*#__PURE__*/React.createElement("div", {
      id: "nav".concat(id).concat(i),
      className: "a-hero__nav--marker",
      onClick: function onClick() {
        return setCurrent(i);
      },
      key: "nav".concat(x._id)
    });
  })));
};
export default NewsArticle;